module.exports = __webpack_public_path__ + "static/media/googleMap範例.mp4";